import React, { useEffect } from 'react'
import logo from '../assets/filenameArtboard 1_2x.png'
import AOS from 'aos';
import {Link} from 'react-router-dom'
import 'aos/dist/aos.css';

const Header = () => {
    useEffect(() => {
        AOS.init({
            duration: 1500,
            easing: 'ease'
        })
    }, [])
    return (
        <div className='header_conatiner'>
            <nav className="navbar navbar-expand-lg navbar-light ">
                <div className="container-fluid">
                    <img className='logo' src={logo} alt="" />
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="#Propuesta">Propuesta</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link"  href="#form">Contacto</a>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link " href="#brands" tabIndex={-1} aria-disabled="false">Puntos de venta</a>
                            </li> */}
                            <li className="nav-item">
                                <Link className="nav-link " to="/login" tabIndex={-1}>login</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>


        </div>
    )
}

export default Header
